import qz from 'qz-tray'
import html2canvas from 'html2canvas'
export default {
  data () {
    return {
      printerLoading: false,
      connectFailed: false,
      printers: [],
      selectPrinter: '',
      autoPrint: false,
      config: null,
      printStatus: {
        isPrinting: false,
        error: null
      }
    }
  },
  watch: {
    selectPrinter (v) {
      console.info('change printer', v)
      this.initConfig()
    }
  },
  methods: {
    async initQZ () {
      this.printerLoading = true
      await this.setupQZSecurity()
      await this.connectQZ()
    },

    initConfig () {
      this.config = qz.configs.create(this.selectPrinter)
      return this.config
    },

    async setupQZSecurity () {
      qz.security.setCertificatePromise((resolve) => {
        resolve(
          '-----BEGIN CERTIFICATE-----\nMIIFfzCCA2egAwIBAgIUJyiKlp44I9wB1Jp57PoCOjCfYPowDQYJKoZIhvcNAQEN\nBQAwaDELMAkGA1UEBhMCVVMxDTALBgNVBAgMBHZpdGUxEDAOBgNVBAcMB3ZpdGV1\nc2ExEDAOBgNVBAoMB3ZpdGV1c2ExEDAOBgNVBAsMB3ZpdGV1c2ExFDASBgNVBAMM\nC3ZpdGV1c2EuY29tMB4XDTI1MDMyNDE0NTY0MFoXDTM1MDMyMjE0NTY0MFowaDEL\nMAkGA1UEBhMCVVMxDTALBgNVBAgMBHZpdGUxEDAOBgNVBAcMB3ZpdGV1c2ExEDAO\nBgNVBAoMB3ZpdGV1c2ExEDAOBgNVBAsMB3ZpdGV1c2ExFDASBgNVBAMMC3ZpdGV1\nc2EuY29tMIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAzD3TMoaod6fW\n8LAEUqS6kLkfSRheyyB4JJd5UaXJ+BY0H/I1r+O5SBvKUKrIL4ht40wXqPuXzBEm\n3HUq4T0t970357bYr3zX1GR2cgv6UD5N3AqpA4W7ZjQOvF/w41r/Tb9lhHu1Xytl\n5mPZ7WNAjcCi9HDjjF+GrimCbzbTCdiOY0VaVagGPVyBJS8gQQLPvyN20fQTsMvS\nj0FYCBgqavi8XG1PodoVzJSvUsHdobdiRwmCk+VhiUJQjwkifeIbPO4FuHe9B323\nj/SEApkd94Edgk4/IsxKIcyub0h6r0+Qz53DXAV3+7Q3f66bwPZzprCVx5j1dfEn\nniy/id+lgw2EBn4tvujFzq46ufEM+OJGlrkVn5DtZ7ZRDkjJyslu0nl7P5bBQFCo\nN8nuEDIuy83EYArIMEheB5lHIV4q5J6WaBUTA0+zXOHkzBwAjI9f5kGePEfGehxX\nlDCs25iHw/0MAfiBFAcHLYCXXFwyVgP3IQ7a+RNsWAiZJxlmPELTE39M7Y6NXRgH\nlHSy3ESUksguJXf5RGhCRVpcKpGEpPwwwghX2Uu0GKY3R3sNiFtdrrG75K52tRzg\nJPGaJtREDuvVUEIj+xt5+u2hs40e/6qTHuVXivdR4U6C+oM+U/Gbi8OQF81aitaV\n2fRMzr6QCgQaDKWIpLQke3y/mJz24tkCAwEAAaMhMB8wHQYDVR0OBBYEFG6Q0qWF\ntq9YT9Y3TFoCvphyWK0yMA0GCSqGSIb3DQEBDQUAA4ICAQAsQEsUatfufDYHyVWQ\nzz9w/Y6+vRYulcJuVKx7gGp+Gt/+KOynCpbrAZTrrq30iRnjSLBkSgX+t1/6b2J7\n/C2UGHNjd3sNUluZ5oB7CX4hzDd3iA4t9m2j4iVmTMr1ig5QZ5CHH6eUHKV0m6Bj\noRfreh7n5PmuTuhXeASahn48qiaUi2wrzr2qKegCZQ7PZmHA8yv5DNGOc2ADAbCh\nsmEhMSqtK+moklKuf42nJCR3i2KFzxhcur4D0NYusO0U61dj5a6EVuEqX7S1jczw\nfGTeiyzhIX52JuFUw8PMPB5HlaTNk5G172de6KH9z92kDff4PdQt9SR5Tbnd6GvY\no5n5Qls/0adC68pHoAURv5uxk+qaSvGoQLj5oQ1V+On6l7JE7ONKUGFRazIlTWcS\nbzjEenQaqBPozGbjyjifsBTiHagEXrmPbCT853x2TwaaFS+FlH0c1a6oLytWb87G\nGbUNB7zFEaJstCmymqBd2D82gsLhcdHJAiaLCqQDf9FNUpXFDuO0q3pG/Wgp3/GH\nKjUSKMl5gCkEcoMXyKE1QAEd6St7Zoe1idTtn1ky4LwuN4NagniC40B1cwmLJ1kk\nVgeT8XZWVAXHR52S/YkeXfl2yu7802SQjXOjjvCQwLwkTz3D6uZw7di9ZDcEmAmx\nIsAeqAcMeFSQoP6Dw/zR8lxFuA==\n-----END CERTIFICATE-----\n'
        )
      })

      qz.security.setSignatureAlgorithm('SHA512')

      qz.security.setSignaturePromise((toSign) => {
        return async (resolve, reject) => {
          try {
            const { data } = await this.$store.dispatch('processSignature', {
              toSign
            })
            this.printerLoading = false
            resolve(data)
          } catch (err) {
            reject(err)
          }
        }
      })
    },

    async connectQZ () {
      if (!qz.websocket.isActive()) {
        try {
          await qz.websocket.connect({ usingSecure: true })
          const defaultPrinter = await qz.printers.getDefault()
          this.selectPrinter = defaultPrinter
          this.autoPrint = true
          this.printers = await qz.printers.find()
          this.printerLoading = false
        } catch (err) {
          this.connectFailed = true
          this.printerLoading = false
          throw err
        }
      }
    },

    async printLabel (data, jobName) {
      this.printStatus.isPrinting = true
      this.printStatus.error = null

      try {
        const printJobName = jobName || '(QZ Tray PDF Print)'
        const config = { ...this.config }
        config.config = { ...config.config, jobName: printJobName }
        await qz.print(config, data)
        this.printStatus.isPrinting = false
        return true
      } catch (err) {
        this.printStatus.error = err
        this.printStatus.isPrinting = false
        throw err
      }
    },

    async disconnectQZ () {
      if (qz.websocket.isActive()) {
        try {
          await qz.websocket.disconnect()
        } catch (err) {
          throw err
        }
      }
    },

    async generatePreview (content) {
      try {
        const canvas = await html2canvas(content, { scale: 1 })
        return {
          imageData: canvas.toDataURL('image/png'),
          base64Data: canvas.toDataURL('image/png').split(',')[1]
        }
      } catch (err) {
        throw err
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/qzTools.js